/**
 * The URL segment the Integrations screen lives at under the Clarity section:
 * `/clarity/settings/integrations`.
 *
 * Shared for the same reason {@link CLARITY_TASKS_ROUTE_SEGMENT} is: the screen's own route in
 * `@efficiently/client-feat-clarity-work` and the shell's user-menu link must agree on it, and
 * `type:util` is the one layer both may reach — the menu lives in the application, which cannot
 * import a `type:feat` library to read a string off it.
 *
 * Two segments rather than one, because the screen is a settings page and not a tab: it carries no
 * working domain and has no entry in the control-centre strip.
 */
export const CLARITY_INTEGRATIONS_ROUTE_SEGMENT = 'settings/integrations';
